export default __webpack_public_path__ + "38cc9b21cfa30511f18decb06e554300.svg";